export function getPlatform() {
  if (window.Telegram?.WebApp?.initData) return 'telegram';
  if (window.WebApp?.initData) return 'max';
  return 'web';
}

export function getInitData() {
  const platform = getPlatform();
  if (platform === 'telegram') return window.Telegram.WebApp.initData;
  if (platform === 'max') return window.WebApp.initData;
  return null;
}

export function getUser() {
  const platform = getPlatform();
  if (platform === 'telegram') return window.Telegram.WebApp.initDataUnsafe?.user || null;
  if (platform === 'max') return window.WebApp.initDataUnsafe?.user || null;
  return null;
}

export function getUserId() {
  const user = getUser();
  return user?.id || null;
}

export function isMiniApp() {
  return getPlatform() !== 'web';
}

export function expandMiniApp() {
  const platform = getPlatform();
  if (platform === 'telegram') window.Telegram.WebApp.expand();
  if (platform === 'max') window.WebApp.expand();
}

export function closeMiniApp() {
  const platform = getPlatform();
  if (platform === 'telegram') window.Telegram.WebApp.close();
  if (platform === 'max') window.WebApp.close();
}
